const concatIncoterm = (incoterm1, incoterm2) => {
    let concat = [
        incoterm1?.code || incoterm1,
        incoterm2?.code || incoterm2,
    ]

    return concat.filter((ic) => ic).join(" - ")
}

export {
    concatIncoterm
}